function trimSlashes(string = '') {
  return string
    .trim()
    .replace(/^\//gi, '')
    .replace(/\/$/gi, '');
}

function pathJoin(...segments) {
  segments = [].concat(...segments);
  return ['', ...segments.map(trimSlashes).filter(Boolean), ''].join('/');
}

function getLocalePath(locale) {
  return locale === 'en' ? '' : locale;
}

function isFullSiteLink(link) {
  return /^https?:\/\//.test(link);
}

function stripIndents(string) {
  return string.replace(/\n[\t\s]*/g, '\n');
}

module.exports = {
  trimSlashes,
  pathJoin,
  getLocalePath,
  isFullSiteLink,
  stripIndents,
};
